import { IAcl } from '@carm/_core/access-control-mgt/models/acl.model';
import { ICypressDataIdentifier } from '.';

export enum ApplicationFeatureName {
    SETUP_MY_PORTAL,
    ACCOUNTS_AND_PROFILES,
    FINANCIAL_INFORMATION,
    PAYMENTS,
    DECLARATIONS,
    RULINGS,
    UPLOADS,
    HOMEPAGE
}

export interface IApplicationFeature extends ICypressDataIdentifier  {
    path: string;
    localizationKey: string;
    acl?: IAcl[];
    sections: IApplicationFeatureSection[];
    numberOfColumns?: number;
}

export interface IApplicationFeatureSection extends ICypressDataIdentifier {
    localizationKey: string;
    path: string;
    acl?: IAcl[];
    columnPosition?: number;
    isClient?: boolean;
    isPublic?: boolean;
    topDivider?: boolean;
    bottomDivider?: boolean;
    requestSource?: string;
}
